// フォントサイズ列挙
export const fontSizeEnum = {
  small: "small", // 小
  middle: "middle", // 中
  big: "large", // 大
};

// 位置列挙
export const positionEnum = {
  center: "center", // 中
  right: "right", // 右
  left: "left", // 左
};

// フォントカラー列挙
export const fontColorEnum = {
  black: "black", // 黒
  red: "red", // 赤
  blue: "blue", // 青
  grey: "grey", // 灰
};

// フォントカラー列挙
export const cookieKeyEnum = {
  token: "auth0Token", // auth0 トークン
  userCode: "userCode", // ユーザーコード
  history: "history", // 検索履歴
  crossHistory: "crossHistory", // 横断検索履歴
  libraryHistory: "libraryHistory", // ライブラリー検索
  secureToken4FirstLogin: "secureToken4FirstLogin", // secureToken4FirstLogin
};

// router列挙
export const routerEnum = {
  sideBarTop: "sideBarTop", // サイドバートップ
  sideBarBottom: "sideBarBottom", // サイドバーボトム
  footer: "footer", // フッター,
  other: "other", // その他
};

// event列挙
export const eventEnum = {
  logout: "logout", // ログアウト
  toggleMenu: "toggleMenu", // トグルメニュー
  fourHundred: "400", // 400
  internetError: "500", // インターネットエラー
  forbidden: "403", // 403禁断の
  notFound: "404", // 404
  search: "search", // サーチ
  login: "login", // ログイン
  updateLoginDate: "updateLoginDate", // パスワード処理をリセット
  refreshToken: "refreshToken", // refreshToken
  // 課金-ADD-START
  updateAuthentication: "updateAuthentication", // updateAuthentication
  // 課金-ADD-END
};

// auth state列挙
export const authStateEnum = {
  auth0: "auth0", // auth0
  web: "web", // ユーザーを装う
  notCertified: "notCertified", // 認証なし
  other: "other", // その他
};

// アクセスモード列挙
export const modeEnum = {
  normal: "normal", // normal
  preview: "preview", // preview
  pageEditing: "pageEditing", // pageEditing
  dev: "dev", // dev
};

// アクセスモード列挙
export const firstLoginStatusEnum = {
  first: "1", // 初回ログイン
  notFirst: "0", // 再ログイン
  other: "other", // その他
};

// 状態を更新列挙
export const updateStatusEnum = {
  updated: "1", // 更新あり
  notUpdate: "0", // 更新なし
  other: "other", // その他
};

// 存在するかどうか更新列挙
export const existStatusEnum = {
  existence: "1", // 有
  notExistence: "0", // 無
  other: "other", // その他
};

// ルートの種類列挙
export const reportTypeEnum = {
  research: "research", // report
  library: "library", // library
  LPNews: "lpNews", // lp お知らせ
  information: "information", // お知らせ
  other: "other", //その他
};

// library種類列挙
export const libraryTypeEnum = {
  pdf: "pdf", // pdf
  page: "page", // page
  link: "link", // link
};

// auth0 error 列挙
export const auth0ErrorEnum = {
  // unauthorized
  unauthorized: {
    error: "unauthorized",
    description: {
      deniedIP: "Access denied from this IP address",
    },
  },
  invalidState: { message: "Invalid state" },
};

// 既存の顧客契約の更新列挙
export const agreementStatusEnum = {
  notUpdate: 0, // notUpdate
  agreementWillUpdate: 1, // agreementWillUpdate
  agreementUpdated: 2, // agreementUpdated
  // 課金-ADD-START
  paymentAgreementWillUpdate: 3, // paymentAgreementWillUpdate
  paymentAgreementUpdated: 4, // paymentAgreementUpdated
  // 課金-ADD-END
  // 課金-UPD-START
  policyWillUpdate: 5, // policyWillUpdate
  policyUpdated: 6, // policyUpdated
  inquiryWillUpdate: 7, // inquiryWillUpdate
  inquiryUpdated: 8, // inquiryUpdated
  // 課金-UPD-END
};

// タグ値種類列挙
export const tagTypeEnum = {
  report: "report", // report
  library: "library", // library
};

// 配信評価の更新列挙
export const evaluateStatusEnum = {
  default: "0", // ボタンが押されていない
  helpful: "1", // 参考になった
  notHelpful: "2", // 参考にならなかった
};

// アカウント権限情報の列挙
export const menuAuthorityTypeEnum = {
  financial: "01", // 財務分析
  businessMatching: "02", // ビジネスマッチング
  spotHuman: "03", // スポット人材紹介
};

// ルーティングタイプ列挙
export const interceptorTypeEnum = {
  common: "common", // common
  lp: "lp", // lp
  initialPassword: "initialPassword", // initialPassword
  initialCompany: "initialCompany", // initialCompany
  initialUser: "initialUser", // initialUser
  confirmSubTerms: "confirmSubTerms", // confirmSubTerms
};

// business matching menu status
export const BMMenuStateEnum = {
  normal: 0, // normal
  disable: 1, // 反社チェック中
  allowSetting: 2, // ビジネスマッチング利用停止中
};

// BroadcastChannel type enum
export const BroadcastChannelTypeEnum = {
  updateHeaderInfo: "updateHeaderInfo", // updateHeaderInfo
  logout: "logout", // logout
};

// news info should display enum
export const newsInfoDisplayAvailabilityFlagEnum = {
  yes: "1",
  no: "2",
};

// url match enum
export const urlMatchEnum = {
  home: "/home",
  mypage: "/mypage",
  research: "/research",
  library: "/library",
  businessMatching: "/business-matching",
  spotHuman: "/spot-recruitment",
  faq: "/faq",
  settings: "/settings",
  // 課金-ADD-START
  payment: "/premium",
  // 課金-ADD-END
};

export const urlFromEnum = {
  search: "search",
  notification: "notification",
  InnerTab: "InnerTab",
};

export const jumpTypeEnum = {
  NewBrowserTab: "NewBrowserTab",
  InnerTab: "InnerTab",
};

// 課金-ADD-START
// 適用プランコード
export const applicationBillingPlanCodeEnum = {
  free: "00", // 無料プラン
  payment: "01", // ビジネスマッチング支援プラン
};

export const contractInfoManagementStatus = {
  finish: "0", // 完了
  toPayment: "1", // プラン変更中（無料→有料）
  processing: "2", // 継続処理中
  toFree: "3", // プラン変更中（有料→無料）
};
// 課金-ADD-END
